import useAsyncData from "../../../../../hooks/use-async-data";
import billingService from "../../../billings.service";
import BillingsOrderForwardRelatedTaxiDriver from "./billings-order-forward-related-taxi-driver";
import BillingsOrderForwardRelatedTaxiDriverParams from "./billings-order-forward-related-taxi-driver-params";

const useBillingsOrderForwardRelatedTaxiDriver = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsOrderForwardRelatedTaxiDriver>({
      data: [],
    });

  const load = async (
    params: BillingsOrderForwardRelatedTaxiDriverParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const taxiDriver =
        await billingService.getOrderForwardRelatedTaxiDriverBillings(
          params,
          signal,
        );

      setData(taxiDriver);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useBillingsOrderForwardRelatedTaxiDriver;
